<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form">
                <custom-divider label="تنظیمات امنیتی پایه"></custom-divider>
                <v-row dense v-if="$system.license.features.ip_whitelist">
                    <v-col>
                        <v-combobox
                            :rules="$validation('ip')"
                            chips
                            label="لیست IP های مجاز"
                            max
                            multiple
                            v-model="form.ip_whitelist"
                        >
                            <template #chip="{ item, index, props }">
                                <v-chip @click:close="form.ip_whitelist.splice(index,1)" class="ma-1" closable label style="background-color:#ebf4ff" color="#2877dc">
                                    <strong>{{ item.raw }}</strong>
                                </v-chip>
                            </template>
                        </v-combobox>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'با تعریف هر IP در این قسمت دسترسی به سامانه از سایر IPها امکان پذیر نخواهد بود'" class="cursor-help mt-2" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <v-row dense v-if="$system.license.features.ip_blacklist">
                    <v-col>
                        <v-combobox
                            :rules="$validation('ip')"
                            chips
                            label="لیست IP های غیر مجاز"
                            max
                            multiple
                            v-model="form.ip_blacklist"
                        >
                            <template #chip="{ item, index, props }">
                                <v-chip @click:close="form.ip_blacklist.splice(index,1);" class="ma-1" closable label style="background-color:#ebf4ff" color="#2877dc">
                                    <strong>{{ item.raw }}</strong>
                                </v-chip>
                            </template>
                        </v-combobox>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'دسترسی به سامانه از IPهای درج شده در این قسمت امکان‌پذیر نخواهد بود'" class="cursor-help mt-2" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <v-text-field
                            :rules="$validation()"
                            label="تعداد ورود ناموفق پیش از قفل شدن حساب کاربری"
                            v-model="form.failed_login_attempts_count"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'>پس از تعداد ورود ناموفق تنظیم شده سامانه برای مدت 10 دقیقه از ورود کاربر جلوگیری می کند'" class="cursor-help mt-2" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <v-text-field
                            :rules="$validation()"
                            label="مدت زمان خروج خودکار (دقیقه)"
                            v-model="form.auto_logout_time"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'>پس از این مدت زمان در صورت عدم فعالیت کاربر، نشست کاری وی به صورت خودکار منقضی شده و استفاده مجدد از سامانه منوط به ورود مجدد خواهد بود'" class="cursor-help mt-2" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <v-row align="center" no-gutters>
                    <v-col cols="auto">
                        <v-checkbox
                            hide-details
                            label="الزام کاربران برای استفاده از کلمه عبور پیچیده"
                            v-model="form.force_users_using_secure_password"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'>کلمه عبور پیچیده می‌باید دارای حداقل 8 کاراکتر شامل حروف کوچک و بزرگ انگلیسی، اعداد و علامت‌های خاص باشد'" class="cursor-help ms-2" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <v-row no-gutters align="center">
                    <v-col cols="auto">
                        <v-checkbox
                            hide-details
                            label="اجازه ورود چندگانه به حساب کاربری"
                            v-model="form.multiple_login"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-tooltip="'>با فعال بودن این گزینه امکان ورود یک حساب کاربری با دستگاه ها یا مرورگرهای مختلف بصورت همزمان می باشد'" class="cursor-help ms-2" color="secondary" size="18">info</v-icon>
                    </v-col>
                </v-row>
                <div class="mt-4" v-if="$system.license.features.log">
                    <custom-divider label="تنظیمات لاگ"></custom-divider>
                    <v-text-field
                        :rules="$validation()"
                        label="حداکثر تعداد رکورد لاگ"
                        v-model="form.log_count"
                    ></v-text-field>
                    <v-select
                        :rules="$validation()"
                        :items="[ {id: 'GET', name: 'دریافت'}, {id: 'POST', name: 'ایجاد'}, {id: 'PUT', name: 'ویرایش'}, {id: 'DELETE', name: 'حذف'} ]"
                        label="عملکرد های قابل ذخیره"
                        item-title="name"
                        item-value="id"
                        clearable
                        multiple
                        v-model="form.log_methods"
                    ></v-select>
                </div>
                <div class="mt-4" v-if="$system.license.features.api_core">
                    <custom-divider label="تنظیمات API"></custom-divider>
                    <p class="text-small mb-6 text-grey-darken-2">از تنظیمات زیر برای اتصال امن سایر نرم‌افزارهای خود به هلپیکال استفاده نمایید <a href="https://api.helpical.com/g2" class="text-secondary text-decoration-none" target="_blank" rel="nofollow">(مستندات API)</a>.<br></p>
                    <v-text-field
                        class="arial-input"
                        label="کلید محرمانه ارتباط با API"
                        v-model="form.api_secret_key"
                        readonly
                    >
                        <template #append-inner>
                            <v-icon class="cursor-pointer me-2" color="primary" @click="form.api_secret_key = null" v-if="form.api_secret_key">clear</v-icon>
                            <v-icon class="cursor-help me-2" color="primary" size="21" @click="$text.copy(form.api_secret_key)" v-if="form.api_secret_key">content_copy</v-icon>
                            <v-icon v-tooltip="'ایجاد کلید جدید'" class="cursor-pointer" color="primary" @click="form.api_secret_key = uuid()">refresh</v-icon>
                        </template>
                    </v-text-field>
                    <v-combobox
                        :rules="$validation('ip')"
                        chips
                        label="لیست IP های مجاز برای ارتباط با API"
                        max
                        multiple
                        v-model="form.api_ip_whitelist"
                    >
                        <template #chip="{ item, index, props }">
                            <v-chip @click:close="form.api_ip_whitelist.splice(index,1)" class="ma-1" closable style="background-color:#ebf4ff" color="#2877dc">
                                <strong>{{ item }}</strong>&nbsp;
                            </v-chip>
                        </template>
                    </v-combobox>
                </div>
                <div class="mt-4">
                    <v-btn type="submit" color="success" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn @click="$router.push({path: '/settings'})" class="ms-3" color="error" variant="text" :disabled="loading">بازگشت به تنظیمات</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
    title: "تنظیمات امنیتی",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            formPermissionList: {
                log_count: this.$system.license.features.log,
                log_methods: this.$system.license.features.log,
                api_secret_key: this.$system.license.features.api_core,
                api_ip_whitelist: this.$system.license.features.api_core,
                ip_whitelist: this.$system.license.features.ip_whitelist,
                ip_blacklist: this.$system.license.features.ip_whitelist,
            },
            form: {
                auto_logout_time: this.$system.settings.auto_logout_time,
                failed_login_attempts_count: this.$system.settings.failed_login_attempts_count,
                force_users_using_secure_password: this.$system.settings.force_users_using_secure_password,
                multiple_login: this.$system.settings.multiple_login,
                log_count: null,
                log_methods: null,
                api_secret_key: null,
                api_ip_whitelist: [],
                ip_whitelist: [],
                ip_blacklist: [],
            },
        };
    },
    methods: {
        uuid() {
          return uuidv4().toUpperCase();
        },
        submit() {
            this.loading = true;
            this.$updateSettings({ ...this.form, _method: 'put'}).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.setGlobalSettings(true);
                }
            }).finally(()=>{this.loading = false});
        },
    },
    created() {
        for (const key in this.formPermissionList) {
            if (this.formPermissionList[key])
                this.form[key] = Array.isArray(this.$system.settings[key]) ? [...this.$system.settings[key]] : this.$system.settings[key];
            else
                delete this.form[key];
        }
    },
};
</script>
